import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
    ConfigProvider,
    Button,
    Form,
    Input,
    Select,
    Modal,
    Row,
    Spin,
    Col,
    Empty,
    Pagination,
    message,
    Divider
} from "antd";
import type { PaginationProps } from "antd";
import { useNavigate } from "react-router-dom";
import { publicPath } from "@/utils/base";
import { appNameReg } from "@/utils/constant";
import {getRulesDetail} from "@/utils";
import api from "@/api";
import "./index.less";

import dataJson from "@/../public/data.json";
import { cloneDeep } from "lodash-es";
import {useSelector} from "react-redux";
const prefix = "superDeviceTemplateDetail-businessrules";

function BusinessRules() {
    const { super_device_template_detail,rules_list, req_err, create, two_bars, rules_detail, release, add_create } = dataJson;
    const { id } = useParams();
    const superDeviceTemplateDetail = useSelector((state: any) => state.superDeviceTemplateDetail);
    const filterFormJson = rules_list.filter_form;
    const addFormJson = rules_list.add_form;

    const [addOpen, setAddOpen] = useState(false);
    const [addOpenLoading, setAddFormLoading] = useState(false);
    const [pageData, setPageData] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState(false);

    const [filterForm] = Form.useForm();

    const [addForm] = Form.useForm();

    const navigate = useNavigate();

    const pageInit = {
        pageSize: 20,
        pageNo: 1,
    };
    const pageNo = useRef<number>(pageInit.pageNo);
    const pagesize = useRef<number>(pageInit.pageSize);

    const onFilter = () => {
        pageNo.current = pageInit.pageNo;
        pagesize.current = pageInit.pageSize;
        getPageData();
    };

    const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
        pagesize.current = pageSize;
    };

    const getPageData = async () => {
        try {
            setLoading(true);
            const filterFormValues = await filterForm.getFieldsValue();

            const res: any = await api.getRuleListApi({
                page: pageNo.current,
                limit: pagesize.current,
                keyword: filterFormValues.name,
                superModelIds: [id]
            });
            if (res.code === 200) {
                const dataCopy = cloneDeep(res.data.datas);
                const list = dataCopy.map((item: any) => {
                    item.iconImg = item?.resources?.find((ele: any) => ele.type == "ICON")?.url;
                    const showModeItem = release.show_mode_arr?.find((ele: any) => ele.value === item.showMode);

                    item.title = showModeItem?.title;
                    item.textColor = showModeItem?.textColor;
                    item.bgColor = showModeItem?.bgColor;
                    return item;
                });

                setPageData(list);
                setTotal(Number(res?.data?.total));
                setLoading(false);
            } else {
                setLoading(false);
                message.error(res.msg || req_err);
            }
        } catch (errorInfo: any) {
            console.error(errorInfo);
            setPageData([]);
            setTotal(0);
            setLoading(false);
        }
    };

    const validateName = (_: any, value: any) => {
        if (value) {
            return api.checkRuleNameApi({ name: value }).then((resp: any) => {
                if (resp.code === 200) {
                    if (resp.data?.exist) {
                        return Promise.reject(new Error(rules_list.name_already));
                    }
                } else {
                    return Promise.resolve();
                }
            });
        } else {
            return Promise.resolve();
        }
    };

    const showAddModal = () => {
        setAddOpen(true);
    };

    const handleAddOpenOk = async () => {
        try {
            const addValues = await addForm.validateFields();
            setAddFormLoading(true);
            const res: any = await api.createRuleDataApi({
                name: addValues.name,
                subType: ["RULE_ENGINE"],
                superModelId: id
            });
            if (res.code === 200) {
                message.success(rules_list.creat_success);
                setAddOpen(false);
                setAddFormLoading(false);
                navigate(`${publicPath}/rules_detail/info/${res.data.id}`);
            } else {
                setAddFormLoading(false);
                message.error(res.msg || req_err);
            }
        } catch (errorInfo: any) {
            console.error(errorInfo);
            setAddFormLoading(false);
        }
    };

    const handleAddCancel = () => {
        setAddOpen(false);
    };

    const clickCard = (item: any) => {
        getRulesDetail(item.id, () => {
            navigate(`${publicPath}/rules_detail/info/${item.id}`);
        });
    };

    useEffect(() => {
        getPageData();
    }, [superDeviceTemplateDetail]);

    return (
        <div className={prefix}>
            <div className={`${prefix}-inner`}>
                <div className={`${prefix}-header`}>
                    <div className={`${prefix}-header-text`}>
                        <div className={`${prefix}-header-title`}>{super_device_template_detail.menu[3].label}</div>
                        <div className={`${prefix}-header-tip`}>{super_device_template_detail.business_rules_tip}</div>
                    </div>
                </div>
                <div className={`${prefix}-content`}>
                    <div className={`${prefix}-content-list`}>
                        <div className={`${prefix}-content-list-top`}>
                            <Form form={filterForm} layout="inline">
                                <Form.Item
                                    name="name"
                                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                                    style={{ marginRight: 56 }}
                                >
                                    <Input placeholder={filterFormJson.name_placeholder} onPressEnter={onFilter} style={{ width: 296 }} />
                                </Form.Item>
                            </Form>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            borderRadius: 0,
                                            paddingInline: 40,
                                            paddingBlock: 8,
                                        },
                                    },
                                }}
                            >
                                <Button type="primary" onClick={showAddModal}>
                                    新建
                                </Button>
                            </ConfigProvider>
                        </div>
                        <Divider />
                        <Spin spinning={loading} size="large" wrapperClassName={`${prefix}-content-list-spin`}>
                            {total === 0 ? (
                                <Empty />
                            ) : (
                                <div className={`${prefix}-content-list-content`}>
                                    {pageData.map((item: any) => {
                                        return (
                                            <div
                                                key={item.id}
                                                onClick={() => {
                                                    clickCard(item);
                                                }}
                                                className={`${prefix}-content-list-content-item`}
                                            >
                                                <div
                                                    className={`${prefix}-content-list-content-status`}
                                                    style={{ color: item?.textColor, backgroundColor: item?.bgColor }}
                                                >
                                                    {item.title}
                                                </div>
                                                <div className={`${prefix}-content-list-content-inner`}>
                                                    <img src={item?.iconImg ? item?.iconImg : rules_list.init_img} alt="" />
                                                    <div>
                                                        <div title={item?.name} className={`${prefix}-content-list-content-title one-line-ellipsis`}>
                                                            {item?.name || two_bars}
                                                        </div>
                                                        <div>{rules_detail.template_name}</div>
                                                        <div title={item?.superModelName || ""} className={`${prefix}-content-list-content-package two-line-ellipsis`}>
                                                            {item?.superModelName || two_bars}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </Spin>
                        <Pagination
                            pageSize={pagesize.current}
                            current={pageNo.current}
                            total={total}
                            showSizeChanger
                            showQuickJumper
                            showTotal={(total) => `共 ${total} 条`}
                            align="end"
                            className={`${prefix}-content-list_page`}
                            onShowSizeChange={onShowSizeChange}
                            onChange={(page: number) => {
                                pageNo.current = page;
                                getPageData();
                            }}
                        />
                        <Modal
                            title={create}
                            centered
                            confirmLoading={addOpenLoading}
                            open={addOpen}
                            okText={add_create}
                            onOk={handleAddOpenOk}
                            onCancel={handleAddCancel}
                            width={328}
                        >
                            <Form form={addForm} layout="vertical">
                                <Form.Item
                                    name="name"
                                    label={addFormJson.name_label}
                                    validateDebounce={500}
                                    rules={[
                                        { required: true, message: addFormJson.name_placeholder },
                                        {
                                            pattern: appNameReg,
                                            message: rules_detail.name_validator,
                                        },
                                        { validator: validateName },
                                    ]}
                                >
                                    <Input showCount maxLength={30} placeholder={addFormJson.name_placeholder} />
                                </Form.Item>
                            </Form>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BusinessRules;
